import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { OnboardingModuleStatuses } from '../../enums/onboarding-module-status.enum';
import { EnrollmentExtendedService } from '../../services/onboarding/enrollment-extended.service';
import { IAppState } from '../../store/common/interfaces/app-state.interface';
import { selectModuleStatuses } from '../../store/onboarding/reducers+selectors/enrollment.selector';

@Injectable({
  providedIn: 'root',
})
export class FinancialProfileGuard implements CanActivate {
  constructor(
    private ees: EnrollmentExtendedService,
    private store: Store<IAppState>
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const statusIds$ = this.store.select(selectModuleStatuses);
    let businessProfileStatusId = 0;
    let financialProfileStatusId = 0;
    let customerPortfolioStatusId = 0;
    let applicationReviewStatusId = 0;
    const subscription = statusIds$.subscribe(async (props) => {
      businessProfileStatusId = props.businessProfileStatusId;
      financialProfileStatusId = props.financialProfileStatusId;
      customerPortfolioStatusId = props.customerPortfolioStatusId;
      applicationReviewStatusId = props.applicationReviewStatusId;
    });
    subscription.unsubscribe();
    if (
      businessProfileStatusId === OnboardingModuleStatuses.COMPLETED &&
      financialProfileStatusId === OnboardingModuleStatuses.COMPLETED &&
      customerPortfolioStatusId === OnboardingModuleStatuses.COMPLETED &&
      applicationReviewStatusId === OnboardingModuleStatuses.COMPLETED
    ) {
      return false;
    }

    return true;
  }
}
